const titleCaseWords = (str: string): string =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

const capitalizeVehicleText = (str: string | undefined): string | undefined => {
  if (!str) return undefined;
  if (str.toLowerCase() === str || str.toUpperCase() === str) {
    return titleCaseWords(str);
  }
  return str;
};

const normalizeModel = (make: string | undefined, model: string | undefined): string | undefined => {
  if (!model) return undefined;

  const isSlug = model.includes("_");
  let normalized = model;

  if (make) {
    const makeEscaped = make.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const prefixRegex = new RegExp(`^${makeEscaped}[_\\- ]?`, "i");
    normalized = normalized.replace(prefixRegex, "");
  }

  if (isSlug) {
    normalized = normalized.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim();
  }

  return capitalizeVehicleText(normalized);
};

export { capitalizeVehicleText, normalizeModel };
